<template>
    <div class="person-entry-form">
        <div class="row" v-if="!!entry.notebooks.length">
            <div class="card col-12 col-sm-12 m-sm-auto">
                <div class="card-body">
                    <app-pending-notes
                        :notebooks="entry.notebooks"
                        v-model="completedNotes"
                    />
                </div>
            </div>
        </div>
        <div class="alert alert-warning" v-if="!personInside">
            No es posible realizar este ingreso, esta persona ya se encuentra
            dentro de las instalaciones
            <div class="col-12 text-right">
                <hr />
                <button
                    class="btn btn-secondary"
                    @click="$bus.$emit('entry.reset')"
                >
                    <i class="fa fa-times"></i> Volver
                </button>
            </div>
        </div>
        <div class="alert alert-success" v-if="personInside && isAuthorized">
            La persona {{ entry.name }} tiene una autorización previa.
        </div>
        <b-row v-if="authorizationAnswered">
            <b-col cols="12">
                <div class="alert alert-success" v-if="!!authorizationResponse">
                    Acceso Concedido por {{ authorizationResponseBy }}
                </div>
                <div class="alert alert-danger" v-else>
                    Acceso Denegado por {{ authorizationResponseBy }}
                </div>
            </b-col>
        </b-row>
        <div class="row" v-if="personInside">
            <div class="card col-12 col-sm-12 m-sm-auto">
                <div class="card-body">
                    <div class="card-title"></div>
                    <div class="card-text">
                        <div class="row">
                            <!-- Informacion de la persona -->
                            <div class="col-12 col-sm">
                                <form action class="form form-horizontal">
                                    <div class="form-row">
                                        <div class="col-12 camera-spot">
                                            <div
                                                class="person-photo d-flex align-items-center"
                                                v-if="
                                                    !!entry.photo &&
                                                        !changePhoto
                                                "
                                            >
                                                <div
                                                    class="person-photo-photo avatar"
                                                >
                                                    <img
                                                        :src="entry.photo"
                                                        alt
                                                        class="person-photo-spot"
                                                    />
                                                </div>
                                                <div
                                                    class="person-photo-retake ml-2"
                                                >
                                                    <b-button
                                                        variant="primary"
                                                        @click="
                                                            onChangePhoto(true)
                                                        "
                                                        >Cambiar Foto</b-button
                                                    >
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="web-cam-spot">
                                                    <app-web-cam
                                                        :multiple="false"
                                                        @input="onTakePhoto"
                                                        upload
                                                    ></app-web-cam>
                                                </div>
                                                <div class="cancel-button-spot">
                                                    <b-button
                                                        block
                                                        variant="warning"
                                                        @click="
                                                            onChangePhoto(false)
                                                        "
                                                        >Cancelar</b-button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12">
                                            <app-form-text-input
                                                label="Documento"
                                                v-model="entry.document"
                                                :required="true"
                                                error-message="Debe escribir el número de documento correcto"
                                                :has-error="
                                                    $v.entry.document.$error
                                                "
                                            ></app-form-text-input>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12">
                                            <app-form-text-input
                                                label="Nombre"
                                                v-model="entry.name"
                                                :required="true"
                                                :hasError="$v.entry.name.$error"
                                                errorMessage="Debe escribir el nombre del visitante"
                                                @input="$v.entry.name.$touch()"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12">
                                            <app-form-text-input
                                                label="Teléfono"
                                                v-model="entry.phone"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-row" v-if="!isInternal">
                                        <div class="col-12">
                                            <app-form-text-input
                                                label="Empresa"
                                                v-model="entry.company"
                                            ></app-form-text-input>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-12">
                                            <app-form-text-input
                                                label="Cargo"
                                                v-model="entry.position"
                                                @input="
                                                    !entry.internal &&
                                                        $v.entry.position.$touch()
                                                "
                                            ></app-form-text-input>
                                        </div>
                                    </div>
                                    <div class="form-row" v-if="!isInternal">
                                        <div class="col-12">
                                            <app-form-select-input
                                                label="Tipo de visitante"
                                                :options="visitorTypes"
                                                :hasError="
                                                    $v.entry.visitorTypeId
                                                        .$error
                                                "
                                                errorMessage="Debe seleccionar el tipo de visitante"
                                                @change="
                                                    $v.entry.visitorTypeId.$touch()
                                                "
                                                v-model="entry.visitorTypeId"
                                                :required="true"
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <!-- fin informacion de la persona -->
                            <!-- informacion de la visita -->
                            <div class="col-12 col-sm">
                                <!-- <div class="row">
                                    <div class="col-6">
                                        <app-form-text-input
                                            label="Temperatura"
                                            v-model="entry.temperature"
                                            type="number"
                                        ></app-form-text-input>
                                    </div>
                                    <div class="col-6">
                                        <b-form-group
                                            label="Elementos bioseguridad"
                                        >
                                            <b-btn-group>
                                                <b-btn
                                                    :variant="
                                                        entry.bioprotection ===
                                                        '1'
                                                            ? 'success'
                                                            : 'secondary'
                                                    "
                                                    @click="
                                                        entry.bioprotection =
                                                            '1'
                                                    "
                                                    >SI</b-btn
                                                >
                                                <b-btn
                                                    :variant="
                                                        entry.bioprotection ===
                                                        '0'
                                                            ? 'danger'
                                                            : 'secondary'
                                                    "
                                                    @click="
                                                        entry.bioprotection =
                                                            '0'
                                                    "
                                                    >NO</b-btn
                                                >
                                            </b-btn-group>
                                        </b-form-group>
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-12">
                                        <app-form-select-input
                                            :options="arls"
                                            v-model="entry.arlId"
                                            label="ARL"
                                        ></app-form-select-input>
                                    </div>
                                </div>
                                <div class="row" v-if="!isInternal">
                                    <div class="col-12">
                                        <!-- <app-autocomplete type="people_structures" label="Destino" :required="true" v-model="destinationObject" @change="$v.entry.destinationId.$touch()"></app-autocomplete>
                                        <span v-if="$v.entry.destinationId.$error" class="field-error">Debe especificar el destino</span>-->
                                        <!-- <app-autocomplete
                                            :items="destinations"
                                            key-prop="structure_id"
                                            label-prop="destination"
                                            results-prop="destination"
                                            label="Destino"
                                            required="true"
                                            v-model="destination"
                                            @change="onDestinationChange"
                                            :disabled="!visitorIdentified"
                                        ></app-autocomplete> -->
                                        <autocomplete
                                            label="Destino"
                                            :required="true"
                                            label-prop="destination"
                                            :items="destinations"
                                            results-property="destination"
                                            placeholder="Buscar"
                                            results-display="destination"
                                            @change="onDestinationChange"
                                            v-model="destination"
                                        />
                                        <span
                                            v-if="$v.destination.$error"
                                            class="field-error"
                                            >Debe especificar el destino</span
                                        >
                                    </div>
                                </div>
                                <div class="row" v-if="!isInternal">
                                    <div class="col-12">
                                        <autocomplete
                                            :items="filteredPeopleByStructure"
                                            label="Persona que autoriza el ingreso"
                                            :required="true"
                                            v-model="approvedByObject"
                                            label-prop="destination"
                                            :disabled="!destinationSelected"
                                        ></autocomplete>
                                        <span
                                            v-if="$v.entry.approvedById.$error"
                                            class="field-error"
                                            >Debe seleccionar la persona que
                                            autoriza</span
                                        >
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <label for="note">Nuevas notas</label>
                                        <b-form-textarea
                                            id="note"
                                            v-model="entry.notes"
                                            size="sm"
                                        />
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-12">
                                        <label for="notesPrevious"
                                            >Notas previas</label
                                        >
                                        <app-form-textarea-input
                                            :readonly="true"
                                            rows="4"
                                            id="notesPrevious"
                                            v-model="previousNotes"
                                        />
                                    </div>
                                </div>
                                <br />
                                <div class="row" v-if="!isInternal">
                                    <div class="col-12">
                                        <app-objects-info
                                            v-model="objects"
                                        ></app-objects-info>
                                    </div>
                                </div>
                                <div
                                    class="row"
                                    v-if="showFssc22000Form"
                                >
                                    <div class="col-12">
                                        <app-person-entry-fssc22000-form
                                            ref="fssc22000Form"
                                            v-model="fssc22000"
                                            :validation="$v.fssc22000"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="row"
                                    v-if="showSignaturePadForConsent"
                                >
                                    <div class="col-12">
                                        <signature-pad-topaz
                                            ref="signaturePadConsent"
                                            v-model="entry.dataConsent"
                                            :policy-url="dataConsentPolicyUrl"
                                        />
                                        <span
                                            v-if="$v.entry.dataConsent.$error"
                                            class="field-error"
                                            >Debe capturar y guardar la firma de
                                            consentimiento</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <!-- fin informacion de la visita -->
                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <hr />
                                <button
                                    class="btn btn-secondary"
                                    @click="$bus.$emit('entry.reset')"
                                >
                                    <i class="fa fa-times"></i> Volver
                                </button>
                                <button
                                    class="btn btn-confirm"
                                    id="btn-register"
                                    ref="regbutton"
                                    autofocus
                                    :disabled="
                                        inProgress ||
                                            (authorizationAnswered &&
                                                !authorizationResponse)
                                    "
                                    @click="registerEntry"
                                >
                                    <i class="fa fa-save"></i> Registrar Ingreso
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-pop-up
            id="restricted-visitor-window"
            size="large"
            :on-close="confirmRestrictedVisitor"
            title="Visitante Restringido"
        >
            <template slot="body">
                <app-restricted-visitor-card :visitor="restrictedVisitor" />
            </template>
            <template slot="buttons">
                <b-btn variant="danger" @click="acceptRestrictedVisitor">
                    <i
                        class="fa fa-exclamation-triangle"
                        aria-hidden="true"
                    ></i>
                    Ingresar de todos modos
                </b-btn>
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import Autocomplete from '../../../../UI/Controls/AutocompleteV3/Autocomplete'
import ObjectsInfo from './ObjectsInfo.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import PopUp from '../../../../UI/Controls/PopUp/PopUp.vue'
import FormTextInput from '../../../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../../../UI/Controls/Forms/FormSelectInput.vue'
import FormTextareaInput from '../../../../UI/Controls/Forms/FormTextareaInput.vue'
import { alphaSpaces } from '../../../../../utils/CustomValidators'
import PendingNotes from './PendingNotes.vue'
import { mapGetters } from 'vuex'
import WebCam from '../../../../UI/Controls/WebCam/WebCam.vue'
import RestrictedVisitorCard from '../RestrictedVisitorCard/RestrictedVisitorCard'
import SignaturePadTopaz from '../../../../SignaturePadTopaz.vue'
import PersonEntryFssc22000Form, {
    emptyFssc22000Form,
} from './PersonEntryFssc22000Form.vue'
import arlsRepository from '@repositories/arls.repository'
import base2 from '../../../../../repositories/base2.repository'
import repo from '../../../../../repositories/repo'
// import Autocomplete from 'vuejs-auto-complete'

const rightDocument = value => value !== '0'

const fsscChoiceRequired = value =>
    value === '0' || value === '1' || value === 0 || value === 1

export default {
    components: {
        Autocomplete,
        appObjectsInfo: ObjectsInfo,
        appPopUp: PopUp,
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput,
        appPendingNotes: PendingNotes,
        appWebCam: WebCam,
        appRestrictedVisitorCard: RestrictedVisitorCard,
        SignaturePadTopaz,
        appPersonEntryFssc22000Form: PersonEntryFssc22000Form,
    },
    props: ['document'],
    data() {
        return {
            entry: {
                document: '',
                photo: '',
                name: '',
                phone: '',
                company: '',
                position: '',
                purpose: '',
                destinationId: '',
                visitorTypeId: '',
                notes: '',
                internal: '',
                photoChanged: false,
                visitedPersonId: '',
                notebooks: [],
                approvedById: '',
                arlId: '',
                temperature: '',
                bioprotection: '',
                dataConsent: '',
            },
            previousNotes: '',
            destination: '',
            approvedByObject: '',
            objects: [],
            // visitorTypes: [],
            cameraStatus: 'off',
            completedNotes: [],
            personInside: true,
            isAuthorized: false,
            changePhoto: false,
            tmpPhoto: '',
            restrictedVisitor: '',
            confirmedRestrictedVisitor: false,
            authorizationResponse: false,
            authorizationAnswered: false,
            authorizationResponseBy: '',
            filteredPeople: [],
            destinationSelected: false,
            destinations: [],
            selectedDestination: null,
            dataConsentPolicyUrl: '',
            /** Contenido de people.data_consent cuando ya existe visitante en BD */
            personStoredDataConsent: null,
            fssc22000: emptyFssc22000Form(),
        }
    },
    validations() {
        let entry = {}
        //let approvedByObject = {}
        let destination = {}
        if (this.isInternal) {
            entry = {
                document: { required, rightDocument },
                name: { required, alphaSpaces },
            }
        } else {
            entry = {
                document: { required, rightDocument },
                name: { required, alphaSpaces },
                visitorTypeId: { required },
                destinationId: { required },
                visitedPersonId: { required },
                position: { alphaSpaces },
                approvedById: { required },
                dataConsent: {
                    required: requiredIf(function () {
                        return (
                            !this.isInternal &&
                            this.moduleEnabled('user_data_consent') &&
                            !this.isEmployeeVisitorType &&
                            !this.hasPersonDataConsentStored
                        )
                    }),
                },
            }
            //approvedByObject = { required }
            destination = { required }
        }

        let fssc22000 = {}
        if (this.showFssc22000Form) {
            fssc22000 = {
                pension_fund: { required },
                eps: { required },
                emergency_contact_name: { required },
                emergency_contact_phone: { required },
                is_in_good_health_today: { required: fsscChoiceRequired },
                symptoms_last_7_days: { required },
                has_current_wound_or_injury: { required: fsscChoiceRequired },
                is_under_medical_treatment: { required: fsscChoiceRequired },
                diagnosed_with_infectious_disease_last_month: {
                    required: fsscChoiceRequired,
                },
                has_gastrointestinal_symptoms: { required: fsscChoiceRequired },
                had_recent_contact_with_infectious_person: {
                    required: fsscChoiceRequired,
                },
                has_unprotected_wounds_near_food: { required: fsscChoiceRequired },
                uses_ppe_correctly: { required: fsscChoiceRequired },
                food_handling_training_status: { required },
            }
        }

        return { entry, destination, fssc22000 }
    },
    watch: {
        destination(dest) {
            this.entry.destinationId = dest.structure_id
            this.entry.visitedPersonId = !!dest.person_id
                ? dest.person_id
                : null
        },
        approvedByObject(val) {
            this.entry.approvedById = val.person_id
        },
        'client.id'(id) {
            if (id) {
                this.loadDataConsentPolicyUrl()
            }
        },
        'entry.visitorTypeId'() {
            if (this.isEmployeeVisitorType) {
                this.entry.dataConsent = ''
            }
        },
        'showSignaturePadForConsent'(show) {
            if (!show) {
                this.entry.dataConsent = ''
            }
        },
    },
    computed: {
        ...mapGetters(['visitorTypes', 'restrictedVisitors', 'people', 'arls']),
        isInternal() {
            return !!this.entry.internal
        },
        thePeople() {
            return this.people.map(item => ({
                ...item,
                name: `${item.structure.name} - ${item.name}`,
            }))
        },
        filteredPeopleByStructure() {
            return this.destinations.filter(
                destination =>
                    destination.type === 'person' &&
                    destination.structure_id == this.destination.structure_id
            )
            // return this.filteredPeople.map(item => ({
            //     ...item,
            //     name: `${item.structure.name} - ${item.name}`,
            // }))
        },
        approvalPeople() {
            return this.people
                .filter(
                    item => item.structure_id === this.destination.structure_id
                )
                .map(item => ({
                    ...item,
                    name: `${item.structure.name} - ${item.name}`,
                }))
        },
        visitorIdentified() {
            return (
                !!this.entry.document &&
                !!this.entry.name &&
                !!this.entry.visitorTypeId &&
                !!this.entry.photo
            )
        },
        hasPersonDataConsentStored() {
            const v = this.personStoredDataConsent
            return v != null && String(v).trim() !== ''
        },
        isEmployeeVisitorType() {
            if (!this.entry.visitorTypeId || !this.visitorTypes.length) {
                return false
            }
            const vt = this.visitorTypes.find(
                t => t.id == this.entry.visitorTypeId
            )
            if (!vt) return false
            const slug = (vt.slug || '').toLowerCase()
            const name = (vt.name || '').toLowerCase().trim()
            return slug === 'empleado' || name === 'empleado'
        },
        showSignaturePadForConsent() {
            return (
                !this.isInternal &&
                this.moduleEnabled('user_data_consent') &&
                !this.isEmployeeVisitorType &&
                !this.hasPersonDataConsentStored
            )
        },
        showFssc22000Form() {
            return !this.isInternal && this.moduleEnabled('form_fssc22000')
        },
    },
    methods: {
        async loadDataConsentPolicyUrl() {
            if (
                !this.client ||
                !this.client.id ||
                !this.moduleEnabled('user_data_consent')
            ) {
                this.dataConsentPolicyUrl = ''
                return
            }
            try {
                const { data } = await base2.get(
                    `clients/${this.client.id}/data-consent-policy`
                )
                this.dataConsentPolicyUrl =
                    (data && data.data_consent) || ''
            } catch (e) {
                this.dataConsentPolicyUrl = ''
            }
        },
        async onDestinationChange(val) {
            this.$v.destination.$touch()
            if (!val) return
            this.entry.destinationId = val.structure_id

            this.approvedByObject = ''
            this.entry.approvedById = ''
            if (val.type === 'person') {
                this.approvedByObject = val
                this.entry.approvedById = val.person_id
            }

            // const { data } = await repo.get(`people`, {
            //     structure: val.structure_id,
            //     venue: this.accessPoint.venue_id,
            // })
            // const approvers = this.destinations.filter(
            //     destination =>
            //         destination.type === 'person' &&
            //         destination.structure_id == val.structure_id
            // )
            // this.filteredPeople = approvers
            this.destinationSelected = true
            this.requestAuthorization()
        },
        onChangePhoto(status) {
            this.changePhoto = status
            if (status) {
                this.tmpPhoto = this.entry.photo
                this.$bus.$emit('webcam.on')
            } else {
                this.entry.photo = this.tmpPhoto
                this.entry.photoChanged = ''
                this.$bus.$emit('webcam.off')
            }
        },
        onTakePhoto(photo) {
            this.entry.photo = photo
            this.entry.photoChanged = true
        },
        selectVisitorType(typeId) {
            this.entry.visitorTypeId = typeId
            this.$v.entry.visitorTypeId.$touch()
        },
        searchDocument() {
            const vr = Object.assign({}, vigilanceRepository)

            const payload = {
                document: this.document,
                clientId: this.client.id,
            }

            vr.searchPersonOrVisitor(payload)
                .then(data => {
                    this.personStoredDataConsent = null
                    //Saber si la persona ya esta dentro de las instalaciones
                    if (data.isInside) {
                        this.personInside = false
                        return
                    }

                    const visitor = data.visitor
                    const lastEntry = data.lastEntry
                    const lastAuthorization = data.lastAuthorization

                    // Seleccionar el boton de registrar si la persona encontrada es interna
                    this.$nextTick(() => {
                        !!visitor.internal && this.$refs.regbutton.focus()
                    })

                    // Revisar si tiene una autorización previa para diligenciar la información
                    this.handleLastAuthorization(lastAuthorization)
                    // Diligenciar los datos de la última visita para agilizar el proceso de registro

                    !validateResult(lastAuthorization) &&
                        this.handleLastEntry(lastEntry)

                    if (!visitor.id) return

                    this.handleControlAccessNotes(visitor.accessControlComments)

                    this.handleVisitorInformation(visitor)
                })
                .catch(error => {
                    this.$nextTick(() => {
                        this.$refs.regbutton.focus()
                    })
                    toastr.error(
                        `Ocurrió un error al buscar el documento (${error})`
                    )
                })
        },
        handleVisitorInformation(visitor) {
            const dc = visitor.data_consent
            this.personStoredDataConsent =
                dc != null && String(dc).trim() !== '' ? dc : null
            this.entry.internal = visitor.internal
            this.entry.name = visitor.name
            this.entry.company = !!visitor.internal
                ? this.client.name
                : visitor.company || ''
            this.entry.position = visitor.position || ''
            this.entry.photo = visitor.photo
            this.entry.notebooks = visitor.notebooks
            !!visitor.arl_id && (this.entry.arlId = visitor.arl_id)
            this.entry.phone = visitor.phone || ''
        },
        handleControlAccessNotes(notes) {
            const noteTypes = { entry: 'Ingreso', departure: 'Salida' }
            this.previousNotes = notes
                .map(
                    item =>
                        `- [${item.created_at}] ${item.notes} (${
                            noteTypes[item.type]
                        })`
                )
                .join('\n')
        },
        handleLastEntry(lastEntry) {
            if (!!lastEntry && Object.keys(lastEntry).length != 0) {
                /**
                 * Se deshabilita la función de predeterminar la última persona
                 * que autoriza el ingreso para poder solicitar la autorización
                 * nuevamente a traves de la app o de correo electrónico (19/11/2019) - Sergio Rios
                 */

                this.entry.visitorTypeId = lastEntry.visitor_type_id
                //this.entry.notes = lastEntry.notes || ''
            }
        },
        handleLastAuthorization(lastAuthorization) {
            if (
                !!lastAuthorization &&
                !!Object.keys(lastAuthorization).length
            ) {
                this.entry.visitorTypeId = lastAuthorization.visitor_type_id

                this.isAuthorized = true

                this.approvedByObject = lastAuthorization.authorized_by

                this.entry.visitedPersonId = lastAuthorization.authorized_by_id

                this.entry.approvedById = lastAuthorization.authorized_by_id

                this.entry.notes = lastAuthorization.notes

                this.destination = {
                    ...lastAuthorization.destination,
                    structure_id: lastAuthorization.destination.id,
                }
            }
        },
        async registerEntry() {
            this.$v.$touch()

            // if(this.document === '00000'){
            //     toastr.warning('Debe escribir el número de documento correcto');
            //     return false;
            // }

            if (this.$v.$invalid) {
                toastr.warning('Debe diligenciar todos los campos obligatorios')
                return false
            }
            if (
                this.showSignaturePadForConsent &&
                this.$refs.signaturePadConsent &&
                !this.$refs.signaturePadConsent.privacyAccepted
            ) {
                toastr.warning(
                    'Debe aceptar la política de tratamiento de datos'
                )
                return false
            }
            console.log(this.entry.approvedById)
            // Construccion del paquete de datos
            const formData = new FormData()
            formData.append('document', this.entry.document)
            formData.append('phone', this.entry.phone)
            formData.append('clientId', this.client.id)
            formData.append('userId', this.user.id)
            formData.append('structureId', this.accessPoint.id)
            formData.append('arlId', this.entry.arlId)
            // formData.append('destinationId', this.entry.destinationId);
            // formData.append('approvedById', this.entry.approvedById)

            this.completedNotes.map(id => formData.append('noteIds[]', id))

            Object.keys(this.entry).map(key =>
                formData.append(key, this.entry[key])
            )

            // verificacion de cambio de foto
            if (!this.entry.photoChanged) {
                formData.delete('photo')
            }

            this.objects.map(object => {
                formData.append('objects[names][]', object.name)
                formData.append('objects[references][]', object.ref)
            })

            if (this.showFssc22000Form) {
                Object.keys(this.fssc22000).forEach(key => {
                    formData.append(`fssc22000[${key}]`, this.fssc22000[key])
                })
            }

            const vr = Object.assign({}, vigilanceRepository)

            const { data } = await repo.post(
                'vigilance/access-control/person-entry',
                formData
            )

            if (data.status) {
                toastr.success('Entrada ingresada correctamente')
                this.restartForm()
                this.$bus.$emit('entry.reset')
            } else {
                const msg = data.msg || 'Ingreso denegado'
                toastr.error(msg)
                if (typeof msg === 'string' && msg.toLowerCase().includes('ingreso denegado')) {
                    this.$bus.$emit('access-control.entry-denied', msg)
                }
            }

            // vr.savePersonEntry(formData)
            //     .then(data => {
            //         toastr.success('Entrada ingresada correctamente')

            //         // Cargar los ingresos
            //         this.$store.dispatch('entries')

            //         this.restartForm()
            //         this.$bus.$emit('entry.reset')
            //     })
            //     .catch(error => {
            //         toastr.error(
            //             'Ocurrió un error al guardar el ingreso del visitante'
            //         )
            //     })
        },
        restartForm() {
            Object.keys(this.entry).map(key => (this.entry[key] = ''))
            this.personStoredDataConsent = null
            this.fssc22000 = emptyFssc22000Form()
            this.$v.$reset()
            this.$nextTick(() => {
                if (
                    this.$refs.signaturePadConsent &&
                    typeof this.$refs.signaturePadConsent.reset === 'function'
                ) {
                    this.$refs.signaturePadConsent.reset()
                }
            })
        },
        validateRestrictedVisitors() {
            const restrictedVisitor = this.restrictedVisitors.find(
                visitor => visitor.document === this.document
            )

            if (!restrictedVisitor) return

            this.restrictedVisitor = restrictedVisitor
            this.$bus.$emit('restricted-visitor-window.open')
        },
        acceptRestrictedVisitor() {
            this.confirmedRestrictedVisitor = true
            this.$bus.$emit('restricted-visitor-window.close')
            this.confirmedRestrictedVisitor = false
        },
        confirmRestrictedVisitor() {
            !this.confirmedRestrictedVisitor && this.$bus.$emit('entry.reset')
        },
        async loadArls() {
            const ar = { ...arlsRepository }
            const { data } = await ar.index()
            this.arls = data
        },
        async requestAuthorization() {
            const payload = {
                name: this.entry.name,
                document: this.entry.document,
                visitorType: this.visitorTypes.find(
                    item => item.id === this.entry.visitorTypeId
                ).name,
                clientId: this.client.id,
                structureId: this.accessPoint.id,
                venueId: this.accessPoint.venue_id,
                destinationId: this.entry.destinationId,
                arlId: this.entry.arlId,
            }

            if (this.entry.photo.startsWith('data:image/')) {
                payload.photo = this.entry.photo
            }

            const vr = { ...vigilanceRepository }
            try {
                vr.requestAuthorization(payload)
                console.log('this is the try of request authorization')
                toastr.info('Autorización solicitada')
            } catch (err) {
                this.handleErrors(err)
            }
        },
        closeChannel() {
            if (this.accessPoint && this.accessPoint.id) {
                // Echo.leave(`AccessPoint.${this.accessPoint.id}`)
            }
        },
        async loadDestinations() {
            const { data } = await repo.get(
                `venues/${this.accessPoint.venue_id}/destinations`
            )
            this.destinations = data
        },
    },
    mounted() {
        this.destinationSelected = false
        this.validateRestrictedVisitors()
        this.searchDocument()
        this.loadDataConsentPolicyUrl()
        // this.loadDestinations()
        this.load('visitorTypes')

        // TODO: enable this when the authorization is ready
        // Echo.private(`AccessPoint.${this.accessPoint.id}`).listen(
        //     '.vigilance.accessAuthorizationResponded',
        //     e => {
        //         this.authorizationResponseBy =
        //             e.accessAuthorization.response_by.name
        //         this.authorizationResponse = e.accessAuthorization.response
        //         this.authorizationAnswered = true
        //         if (!!e.accessAuthorization.response) {
        //             toastr.success('Ingreso autorizado')
        //             // TODO: Setear la persona que autorizó
        //             this.approvedByObject = e.accessAuthorization.response_by
        //             // this.entry.approvedById = e.accessAuthorization.response_by.id;
        //         } else {
        //             toastr.error('Ingreso denegado')
        //         }
        //     }
        // )
    },
    created() {
        // this.searchDocument();
        this.load('arls')
        this.loadDestinations()
        this.load('people', {
            params: {
                venue: this.accessPoint.venue_id,
            },
        })

        this.entry.document = this.document
        this.$bus.$on('searchDocument', this.searchDocument)
    },
}

const validateResult = val => {
    if (Array.isArray(val)) {
        return !!val.length
    }

    if (typeof val === 'object') {
        return !!val && !!Object.keys(val).length
    }

    return !!val
}
</script>
<style scoped>
.avatar img {
    height: 200px;
    border-radius: 8px;
    border: 2px solid #c7ced5;
    padding: 3px;
    margin-bottom: 10px;
    text-align: center;
}
</style>
